module.exports = __webpack_public_path__ + "img/member_card_0.b609058d.png";